export default class IAP {
    constructor() {
        this.productIds = [];
        this.isInitialized = false;
        this.onBuy = function () { };
    }
    deviceready() {
        return new Promise(function (resolve, reject) {
            if (typeof (cordova) === 'undefined') {
                reject(new Error("Cordova not found"));
                return;
            }
            document.addEventListener("deviceready", resolve, false);
            setTimeout(function () { reject(new Error('deviceready has not fired after 5 seconds.')); }, 5100);
        });
    };
    //https://github.com/j3k0/cordova-plugin-purchase/wiki/HOWTO:-Migrate-to-v13
    //https://purchase.cordova.fovea.cc/v/v13.0/discover/micro-example
    async init(productIds) {
        this.productIds = productIds || [];
        await this.deviceready()
        if (typeof (cordova) === 'undefined' || typeof (CdvPurchase) === 'undefined') throw new Error('store plugin not found');

        const { store, ProductType, Platform, LogLevel } = CdvPurchase;


        for (var i = 0; i < productIds.length; i++) {
            var productId = productIds[i];
            var product = store.get(productId, Platform.TEST);
            if (!product) {
                let type = ProductType.CONSUMABLE;
                if (productId.includes('removeads')) type = ProductType.NON_CONSUMABLE;
                if (productId.includes('fullversion')) type = ProductType.NON_CONSUMABLE;
                store.register({ type: type, id: productId, platform: Platform.GOOGLE_PLAY });
                store.register({ type: type, id: productId, platform: Platform.APPLE_APPSTORE });
            }
        }

        //store.verbosity = LogLevel.DEBUG;
        store.error(this.IAPError.bind(this));

        store.when()
            .productUpdated(this.productUpdated.bind(this))
            .approved(this.finishPurchase.bind(this));

        store.initialize([Platform.APPLE_APPSTORE, Platform.GOOGLE_PLAY]);

    }
    productUpdated(product) {
        console.log("productUpdated", product);
    }
    finishPurchase(p) {
        if (p.products) {
            for (var i = 0; i < p.products.length; i++) {
                var product = p.products[i];
                let id = product.id;
                let message = "IAP Purchase Approved: " + id;
                console.log(message);
                if (this.onBuy) this.onBuy(id);
            }
        }

        p.finish(); //consume - required or it will be stuck in the pending state un paid for
    }
    cancelledPurchase(p) {
        let message = "IAP Cancelled Purchase : " + p.id;
        console.log(message);
    }
    errorPurchase(error) {
        let errorMessage = 'IAP ERROR Purchase ' - error.code + ': ' + error.message;
        console.log('ERROR Purchase ' + errorMessage);
    }
    IAPError(error) {
        console.log('ERROR ' + error.code + ': ' + error.message);
    }
    async getCatalog() {
        await this.deviceready();
        if (typeof (cordova) === 'undefined' || typeof (CdvPurchase) === 'undefined') throw new Error('store plugin not found');

        const { store, ProductType, Platform } = CdvPurchase;
        let products = store.products;
        console.log("products", products);

        var productViews = [];
        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            //if (product.state === "valid") {
            var title = (product.title || "").split('(')[0];
            //make common format 
            var productView = {
                productId: product.id,
                title: title,
                price: product.pricing.price,
                description: product.description,
                owned: product.owned,
                canPurchase: product.canPurchase
            };
            productViews.push(productView);
            //}
        }
        return productViews;
    }
    async buy(id) {
        await this.deviceready();
        if (typeof (cordova) === 'undefined' || typeof (CdvPurchase) === 'undefined') throw new Error('store plugin not found');
        const { store, ProductType, Platform } = CdvPurchase;
        //get offer
        let product = store.get(id);
        if(product)
        store.order(product.getOffer());
    }
    consume(id) {

    }
    restore() {
        console.info('restorePurchases()');
        CdvPurchase.store.restorePurchases();
    }
    getPurchases() {
        return this.getCatalog().then((catalog) => {
            let catalogOwned = catalog.filter(i => i.owned);
            return catalogOwned;
        });
    }
}